// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3dsnl","icon":"SortAdornment_icon__3BQNI","up":"SortAdornment_up__1LFHG","down":"SortAdornment_down__1d-13","active":"SortAdornment_active__1BAVy"};